// automatically generated by the FlatBuffers compiler, do not modify

import { ServiceMessage } from "../service/service-message";
import { UsageMessage } from "../usage/usage-message";

export enum OneHotMessageContent {
	NONE = 0,
	Usage_UsageMessage = 1,
	Service_ServiceMessage = 2,
}

export function unionToOneHotMessageContent(
	type: OneHotMessageContent,
	accessor: (obj: ServiceMessage | UsageMessage) => ServiceMessage | UsageMessage | null
): ServiceMessage | UsageMessage | null {
	switch (OneHotMessageContent[type]) {
		case "NONE":
			return null;
		case "Usage_UsageMessage":
			return accessor(new UsageMessage())! as UsageMessage;
		case "Service_ServiceMessage":
			return accessor(new ServiceMessage())! as ServiceMessage;
		default:
			return null;
	}
}

export function unionListToOneHotMessageContent(
	type: OneHotMessageContent,
	accessor: (index: number, obj: ServiceMessage | UsageMessage) => ServiceMessage | UsageMessage | null,
	index: number
): ServiceMessage | UsageMessage | null {
	switch (OneHotMessageContent[type]) {
		case "NONE":
			return null;
		case "Usage_UsageMessage":
			return accessor(index, new UsageMessage())! as UsageMessage;
		case "Service_ServiceMessage":
			return accessor(index, new ServiceMessage())! as ServiceMessage;
		default:
			return null;
	}
}
